import { GraphQLEnumType } from 'graphql'

export type OrderDirection = 'ASC' | 'DESC'

export const orderDirection = new GraphQLEnumType({
  name: 'OrderDirection',
  description: 'Directions to sort a list of items',
  values: {
    ASC: {
      description: 'Ascending order'
    },
    DESC: {
      description: 'Descending order'
    }
  }
})
